export default {
    warehouse: 'Warehouse',
    'material-name-or-num': 'Item ID or name',
    'loss-ratio': 'Impairment percent',
    'count': 'Count',
    'produced-quantity': 'Produced quantity',
    
    'save': 'Save',
    'edit': 'Edit',

    'back-to-the-bond': 'back to bond',
    
    'delete-raw-material': 'Delete raw material',
    'are-you-sure-you-want-to-delete-the-raw-material': 'Do you want to delete this item?',

    'context-menu': {
        edit: 'Edit',
        delete: 'Delete',
    },

    headers: {
        'no': 'Serial',
        'warehouse': 'Warehouse',
        'material': 'Material',
        'count': 'Item',
        'quantity': 'Count',
        'cost-of-one': 'Unit cost',
        'cost': 'Amount',
    },
    total_cost: 'Total cost: ',
    'product-is-updated-successfully': 'The product has been updated successfully.'
}